<template>
  <div class="bills-create-type page page--bills-create-type">
    <div class="page__title">
      <div class="page__title-icon">
        <svg
          width="27"
          height="27"
          viewBox="0 0 27 27"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="27" height="27" rx="8" fill="#64748B" />
          <path
            d="M13.417 8.125C10.4251 8.12476 7.99976 10.5501 8 13.542C7.99976 16.534 10.4251 18.9593 13.417 18.9591C16.409 18.9593 18.8343 16.534 18.8341 13.542L13.417 13.5418V8.125Z"
            fill="white"
          />
          <path
            d="M14.5828 7V12.4173H19.9998C20.0001 9.42508 17.575 6.99952 14.5828 7Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="page__title-text">
        {{ $t('bills-create-type-page.title') }}
      </div>
    </div>
    <div class="bills-create-type__types">
      <div
        class="bills-create-type__item"
        @click="goToRoute('bill-create-base')"
      >
        <div class="bills-create-type__item-icon">
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="44" height="44" rx="15" fill="#DBE7FD" />
            <path
              d="M27.1333 13.1071L25.8333 14.5945L23.9917 13.1071C23.8981 13.0377 23.784 13.0001 23.6667 13.0001C23.5493 13.0001 23.4352 13.0377 23.3417 13.1071L21.5 14.5945L19.6583 13.1071C19.5648 13.0377 19.4507 13.0001 19.3333 13.0001C19.216 13.0001 19.1019 13.0377 19.0083 13.1071L17.1667 14.5945L15.8667 13.1071C15.5078 12.8449 15 13.0939 15 13.5321V29.4679C15 29.9061 15.5078 30.1551 15.8667 29.8929L17.1667 28.4055L19.0083 29.8929C19.1019 29.9623 19.216 29.9999 19.3333 29.9999C19.4507 29.9999 19.5648 29.9623 19.6583 29.8929L21.5 28.4055L23.3417 29.8929C23.4352 29.9623 23.5493 29.9999 23.6667 29.9999C23.784 29.9999 23.8981 29.9623 23.9917 29.8929L25.8333 28.4055L27.1333 29.8929C27.4888 30.1551 28 29.9061 28 29.4679V13.5321C28 13.0939 27.4922 12.8449 27.1333 13.1071ZM25.8333 24.9528C25.8333 25.0988 25.7115 25.2184 25.5625 25.2184H17.4375C17.2885 25.2184 17.1667 25.0988 17.1667 24.9528V24.4216C17.1667 24.2755 17.2885 24.156 17.4375 24.156H25.5625C25.7115 24.156 25.8333 24.2755 25.8333 24.4216V24.9528ZM25.8333 21.7656C25.8333 21.9117 25.7115 22.0312 25.5625 22.0312H17.4375C17.2885 22.0312 17.1667 21.9117 17.1667 21.7656V21.2344C17.1667 21.0883 17.2885 20.9688 17.4375 20.9688H25.5625C25.7115 20.9688 25.8333 21.0883 25.8333 21.2344V21.7656ZM25.8333 18.5784C25.8333 18.7245 25.7115 18.844 25.5625 18.844H17.4375C17.2885 18.844 17.1667 18.7245 17.1667 18.5784V18.0472C17.1667 17.9012 17.2885 17.7816 17.4375 17.7816H25.5625C25.7115 17.7816 25.8333 17.9012 25.8333 18.0472V18.5784Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="bills-create-type__item-details">
          <div class="bills-create-type__item-title">
            {{ $t('bills-create-type.create-new.title') }}
          </div>
          <div class="bills-create-type__item-short-descr">
            <div class="bills-create-type__item-short-descr-text">
              {{ $t('bills-create-type.create-new.short-descr') }}
            </div>
            <div class="bills-create-type__item-short-descr-help" @click.stop>
              <v-popover trigger="click" placement="right">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="9" cy="9" r="9" fill="#DBE7FD" />
                  <path
                    d="M9.72821 11.3433H8.27189V10.5033C8.27189 10.1362 8.31055 9.86537 8.38788 9.69096C8.4738 9.50737 8.65423 9.26871 8.92917 8.97496L9.86998 7.96982C10.0676 7.74033 10.1664 7.45577 10.1664 7.11613C10.1664 6.77649 10.0633 6.49652 9.85709 6.27622C9.65088 6.04673 9.38454 5.93199 9.05804 5.93199C8.73155 5.93199 8.45661 6.04214 8.23322 6.26245C8.01843 6.47357 7.89384 6.75814 7.85948 7.11613H6.30005C6.38597 6.29917 6.68239 5.6612 7.18931 5.20223C7.70482 4.73408 8.34492 4.5 9.1096 4.5C9.87427 4.5 10.4972 4.7249 10.9783 5.17469C11.4595 5.6153 11.7 6.23491 11.7 7.03352C11.7 7.58428 11.5583 8.04325 11.2748 8.41043C11.1115 8.63074 10.9869 8.78679 10.901 8.87858C10.8151 8.97038 10.6991 9.08971 10.553 9.23658C10.4156 9.37427 10.2953 9.49819 10.1922 9.60834C10.0977 9.70932 10.0203 9.79652 9.96019 9.86996C9.80554 10.0719 9.72821 10.3565 9.72821 10.7236V11.3433ZM9.01938 14.4C8.75303 14.4 8.52105 14.3036 8.32344 14.1108C8.12582 13.9089 8.02702 13.6702 8.02702 13.3949C8.02702 13.1103 8.12153 12.867 8.31055 12.6651C8.50816 12.4631 8.74014 12.3622 9.00649 12.3622C9.28143 12.3622 9.51771 12.4631 9.71532 12.6651C9.91294 12.8579 10.0117 13.0965 10.0117 13.3811C10.0117 13.6565 9.91294 13.8951 9.71532 14.0971C9.5263 14.299 9.29432 14.4 9.01938 14.4Z"
                    fill="white"
                  />
                </svg>

                <template v-slot:popover>
                  <div class="bills-create-type__item-info-popup">
                    <div class="bills-create-type__item-info-popup-image">
                      <img
                        :src="'/img/bills/bill-create-base-preview.png'"
                        alt=""
                      />
                    </div>
                    <div class="bills-create-type__item-info-popup-title">
                      {{ $t('bills-create-type.create-new.hint.title') }}
                    </div>
                    <div class="bills-create-type__item-info-popup-text">
                      {{ $t('bills-create-type.create-new.hint.text') }}
                    </div>
                  </div>
                </template>
              </v-popover>
            </div>
          </div>
        </div>
        <div class="bills-create-type__item-arrow">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="29"
              height="29"
              rx="9.5"
              stroke="#E0E6F2"
            />
            <path
              d="M17.5243 14.6491L14.0016 11.1265C13.9201 11.0449 13.8114 11 13.6954 11C13.5794 11 13.4706 11.0449 13.3892 11.1265L13.1297 11.3858C12.9609 11.5548 12.9609 11.8295 13.1297 11.9982L16.0879 14.9564L13.1265 17.9178C13.045 17.9993 13 18.108 13 18.2239C13 18.34 13.045 18.4487 13.1265 18.5303L13.3859 18.7896C13.4674 18.8711 13.5761 18.916 13.6921 18.916C13.8081 18.916 13.9168 18.8711 13.9983 18.7896L17.5243 15.2637C17.606 15.1819 17.6509 15.0727 17.6506 14.9566C17.6509 14.84 17.606 14.7309 17.5243 14.6491Z"
              fill="#666D79"
            />
          </svg>
        </div>
      </div>
      <div
        class="bills-create-type__item"
        @click="goToRoute('bills-templates')"
      >
        <div class="bills-create-type__item-icon">
          <svg
            width="44"
            height="44"
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="44" height="44" rx="15" fill="#DBFDDE" />
            <path
              d="M21.0489 10.927C21.3483 10.0057 22.6517 10.0057 22.9511 10.9271L24.9187 16.9828C25.0526 17.3948 25.4365 17.6738 25.8697 17.6738H32.2371C33.2058 17.6738 33.6086 18.9134 32.8249 19.4828L27.6736 23.2254C27.3231 23.4801 27.1764 23.9314 27.3103 24.3435L29.2779 30.3992C29.5773 31.3205 28.5228 32.0866 27.7391 31.5172L22.5878 27.7746C22.2373 27.5199 21.7627 27.5199 21.4122 27.7746L16.2609 31.5172C15.4772 32.0866 14.4227 31.3205 14.7221 30.3992L16.6897 24.3435C16.8236 23.9314 16.6769 23.4801 16.3264 23.2254L11.1751 19.4828C10.3914 18.9134 10.7942 17.6738 11.7629 17.6738H18.1303C18.5635 17.6738 18.9474 17.3948 19.0813 16.9828L21.0489 10.927Z"
              fill="white"
            />
          </svg>
        </div>
        <div class="bills-create-type__item-details">
          <div class="bills-create-type__item-title">
            {{ $t('bills-create-type.by-template.title') }}
          </div>
          <div class="bills-create-type__item-short-descr">
            <div class="bills-create-type__item-short-descr-text">
              {{ $t('bills-create-type.by-template.short-descr') }}
            </div>
            <div class="bills-create-type__item-short-descr-help" @click.stop>
              <v-popover trigger="click" placement="right">
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="9" cy="9" r="9" fill="#DBE7FD" />
                  <path
                    d="M9.72821 11.3433H8.27189V10.5033C8.27189 10.1362 8.31055 9.86537 8.38788 9.69096C8.4738 9.50737 8.65423 9.26871 8.92917 8.97496L9.86998 7.96982C10.0676 7.74033 10.1664 7.45577 10.1664 7.11613C10.1664 6.77649 10.0633 6.49652 9.85709 6.27622C9.65088 6.04673 9.38454 5.93199 9.05804 5.93199C8.73155 5.93199 8.45661 6.04214 8.23322 6.26245C8.01843 6.47357 7.89384 6.75814 7.85948 7.11613H6.30005C6.38597 6.29917 6.68239 5.6612 7.18931 5.20223C7.70482 4.73408 8.34492 4.5 9.1096 4.5C9.87427 4.5 10.4972 4.7249 10.9783 5.17469C11.4595 5.6153 11.7 6.23491 11.7 7.03352C11.7 7.58428 11.5583 8.04325 11.2748 8.41043C11.1115 8.63074 10.9869 8.78679 10.901 8.87858C10.8151 8.97038 10.6991 9.08971 10.553 9.23658C10.4156 9.37427 10.2953 9.49819 10.1922 9.60834C10.0977 9.70932 10.0203 9.79652 9.96019 9.86996C9.80554 10.0719 9.72821 10.3565 9.72821 10.7236V11.3433ZM9.01938 14.4C8.75303 14.4 8.52105 14.3036 8.32344 14.1108C8.12582 13.9089 8.02702 13.6702 8.02702 13.3949C8.02702 13.1103 8.12153 12.867 8.31055 12.6651C8.50816 12.4631 8.74014 12.3622 9.00649 12.3622C9.28143 12.3622 9.51771 12.4631 9.71532 12.6651C9.91294 12.8579 10.0117 13.0965 10.0117 13.3811C10.0117 13.6565 9.91294 13.8951 9.71532 14.0971C9.5263 14.299 9.29432 14.4 9.01938 14.4Z"
                    fill="white"
                  />
                </svg>

                <template v-slot:popover>
                  <div class="bills-create-type__item-info-popup">
                    <div class="bills-create-type__item-info-popup-image">
                      <img
                        src="/img/bills/bill-create-base-preview.png"
                        alt=""
                      />
                    </div>
                    <div class="bills-create-type__item-info-popup-title">
                      {{ $t('bills-create-type.by-template.hint.title') }}
                    </div>
                    <div class="bills-create-type__item-info-popup-text">
                      {{ $t('bills-create-type.by-template.hint.text') }}
                    </div>
                  </div>
                </template>
              </v-popover>
            </div>
          </div>
        </div>
        <div class="bills-create-type__item-arrow">
          <svg
            width="30"
            height="30"
            viewBox="0 0 30 30"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect
              x="0.5"
              y="0.5"
              width="29"
              height="29"
              rx="9.5"
              stroke="#E0E6F2"
            />
            <path
              d="M17.5243 14.6491L14.0016 11.1265C13.9201 11.0449 13.8114 11 13.6954 11C13.5794 11 13.4706 11.0449 13.3892 11.1265L13.1297 11.3858C12.9609 11.5548 12.9609 11.8295 13.1297 11.9982L16.0879 14.9564L13.1265 17.9178C13.045 17.9993 13 18.108 13 18.2239C13 18.34 13.045 18.4487 13.1265 18.5303L13.3859 18.7896C13.4674 18.8711 13.5761 18.916 13.6921 18.916C13.8081 18.916 13.9168 18.8711 13.9983 18.7896L17.5243 15.2637C17.606 15.1819 17.6509 15.0727 17.6506 14.9566C17.6509 14.84 17.606 14.7309 17.5243 14.6491Z"
              fill="#666D79"
            />
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { RouteHelper } from '@js-app/services/helpers/routes/routes-helper'

export default {
  name: 'BillsCreateType',
  props: ['id'],
  methods: {
    goToRoute(routeName) {
      this.$router.push(RouteHelper.getRoute(routeName, { companyId: this.id }))
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  &--bills-create-type {
    margin-top: 28px;
  }
}
.bills-create-type {
  &__types {
    margin-top: 40px;
    display: flex;
    align-items: center;
  }

  &__item {
    width: calc(50% - 7.5px);
    max-width: 490px;
    margin-right: 15px;
    background: #ffffff;
    box-shadow: 0px 20px 30px rgba(225, 235, 253, 0.38);
    border-radius: 20px;

    display: flex;
    align-items: center;

    padding: 40px 25px 45px 38px;

    transition: transform 0.2s linear;
    cursor: pointer;

    &:hover {
      transform: scale(1.025) translateY(-5px);
    }

    &:nth-child(2n) {
      margin-right: 0;
    }

    &-details {
      margin-right: 20px;
    }

    &-icon {
      width: 44px;
      height: 44px;

      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 18px;

      svg {
        width: 100%;
        height: 100%;
      }
    }

    &-title {
      font-weight: 600;
      font-size: 16px;
      line-height: 28px;
      color: #465a8b;
      margin-bottom: 5px;
    }

    &-short-descr {
      display: flex;
      align-items: center;

      &-text {
        font-weight: 400;
        font-size: 12px;
        line-height: 14px;
        color: #67768a;
      }

      &-help {
        margin-left: 7px;
        display: flex;
        align-items: center;
        justify-content: center;

        width: 18px;
        height: 18px;

        svg {
          width: 100%;
          height: 100%;
        }
      }
    }

    &-arrow {
      margin-left: auto;
    }

    :deep(.bills-create-type__item-info-popup-image) {
      background: #eff5ff;
      border-radius: 12px;
      width: 100%;
      margin-bottom: 18px;
    }

    :deep(.bills-create-type__item-info-popup-title) {
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      display: flex;
      align-items: center;
      color: #27365b;
      margin-bottom: 14px;
    }

    :deep(.bills-create-type__item-info-popup-text) {
      font-weight: 400;
      font-size: 10px;
      line-height: 18px;
      color: #67768a;
    }
  }
}
</style>

<style lang="scss">
.bills-create-type {
  &__item {
    &-info-popup {
      width: 390px;
      padding: 36px;
      background: #ffffff;
      box-shadow: 0 8px 20px rgba(225, 235, 253, 0.38);
      border-radius: 12px;
    }
  }
}
</style>
